/**
 * `handleThrottling` controls a functions execute rate for a specific
 * timeframe. It will restrict the frequency of function executions by adding
 * a minimum time interval between consecutive calls. It helps regulate the
 * execution rate and prevent excessive function calls, ensuring optimal
 * performance and resource utilization.
 */
export default function handleThrottling(callback, delay) {
  let throttling = false;

  return (...args) => {
    if (!throttling) {
      throttling = true;

      callback(...args);

      setTimeout(() => {
        throttling = false;
      }, delay);
    }
  };
}
